<ng-container *ngFor="let toast of toasts">

  <!-- [@slideVertical]  -->
  <div data-id="div_1577441774" class="toast" [ngClass]="toast.state">
    <ui-icon *ngIf="toast.icon as icon"
      [type]="icon.type"
      [icon]="icon.icon"
      [shape]="icon.shape"
      [bg]="icon.bg"
      [color]="icon.color"
      [size]="icon.size"
      [iconSize]="icon.iconSize"
      [rotate]="icon.rotate"
      class="toast-icon">
    </ui-icon>
    <div data-id="div_1577452854" class="toast-inner">
      <p>{{ toast.message }}</p>
    </div>
    <button *ngIf="toast.actionLabel" type="button" class="toast-action" (click)="runToastAction(toast)">
      {{ toast.actionLabel | translate }}
    </button>
    <div data-id="div_1577452867" *ngIf="toast.dismissable" (click)="removeToast(toast)" aria-label="close" class="toast-close">&times;</div>
  </div>

</ng-container>
